module.exports = "<p-growl [(value)]=\"msgs\"></p-growl>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/message/message.component.html
// module id = ../../../../../src/app/shared/component/message/message.component.html
// module chunks = main